import Config from '../Config';
import View from './View';
import {writable} from 'svelte/store';

const token_key = 'authentication_token';
const token = window.localStorage.getItem(token_key) || '';
let content = {
	token,
	attempted: false,
	initialized: false,
	authenticated: false,
	data: false
};

const api = writable(content);

api.setUpdate = () => {
	api.set(content);
};

api.getRequest = async (uri, method, data) => {
	let json = false; try {
		if (!method)
			method = 'get';

		const config = {
			method: method.toUpperCase(),
			headers: {'Accept': 'application/json'}
		};

		if (content.token)
			config.headers['Authorization'] = `Bearer ${content.token}`;

		if (data) {
			config.headers['Content-Type'] = 'application/json';
			config.body = JSON.stringify(data);
		};

		const endpoint = `${Config.api.endpoint}/${uri}`;
		const response = await fetch(endpoint, config);

		const logout = [401, 403];
		if (!logout.includes(response.status)) {
			json = await response.json();
			console.info(json);
		}
		else api.setUserLogOut();
	}
	catch (exception)
		{ console.error(exception); }

	return json;
};

api.setUserLogIn = async (email, password) => {
	try {
		const config = {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({email, password})
		};

		const response = await fetch(`${Config.api.endpoint}/login`, config);
		const json = await response.json();

		content.authenticated = response.status === 200;
		if (content.authenticated) {
			window.localStorage.setItem(token_key, json.access_token);

			content.attempted = true;
			content.initialized = true;
			content.token = json.access_token;
			api.set(content);
			api.setUserCheck(content.token);
		}

		else {
			api.setUserLogOut(true);
			content.attempted = true;
			api.set(content);
		}
	}

	catch (exception) {
		content.attempted = true;
		content.authenticated = false;
		api.set(content);

		console.error(exception);
	}
};

api.setUserCheck = async token => {
	const config = {
		method: 'GET',
		headers: {
			'Accept': 'application/json',
			'Authorization': `Bearer ${token}`
		}
	};

	const response = await fetch(`${Config.api.endpoint}/me`, config);
	const json = await response.json();
	content.attempted = false;
	content.initialized = true;
	content.authenticated = response.status === 200;
	if (content.authenticated) {
		content.data = json;
		api.set(content);
	}
	else api.setUserLogOut(true);
};

api.setUserLogOut = silent => {
	window.localStorage.setItem(token_key, '');

	content.attempted = false;
	content.initialized = true;
	content.authenticated = false;
	content.token = '';
	content.data = false;
	api.set(content);

	if (!silent)
		api.setAuthentication();
};

api.setUser = async (email, password) => {
	try {
		if (email && password)
			await api.setUserLogIn(email, password);
		else if (content.token)
			await api.setUserCheck(content.token);
		else
			await api.setUserLogOut(true);
	}
	catch (exception)
		{ console.error(exception); }
};

api.setAuthentication = async (email, password) => {
	await api.setUser(email, password);
	const view = content.authenticated ? 'dashboard' : 'authentication';
	if (!View.getIs(view))
		View.setView(view);
};

api.setData = async () => {
	try {
		let data = await api.getRequest('me');
		content.data = data;
		api.set(content);
	}
	catch (exception)
		{ console.error(exception); }
};

export default api;